/* Justyol unified ad/analytics layer.

   The COD express + custom checkout create orders via the backend, bypassing
   Shopify's native checkout — so Shopify's automatic Purchase/InitiateCheckout
   pixel events NEVER fire for them. This helper fires the funnel consistently to
   Meta (fbq), GA4 (gtag/dataLayer) and TikTok (ttq), WITH content_ids so Meta
   catalog / dynamic product ads can attribute to the product and the ad.

   content_ids = product ids by default. If your Meta catalog feed keys on
   variant ids instead, set window.JY_FX_IDKEY = 'variant'.
   Every call carries an eventID so a server-side Conversions API event with the
   same id is de-duplicated (wire the backend to emit it for best match quality). */
(function () {
  var CUR = 'MAD';

  /* tag the whole GA4 session as app or web so you can build "app users"
     audiences/segments (not just per-event funnels). Applies to every
     subsequent event. */
  try {
    if (window.gtag) {
      gtag('set', 'user_properties', { jy_platform: window.JY_IS_APP === true ? 'app' : 'web' });
    }
  } catch (e) {}

  function idOf(it) {
    if (it == null) return null;
    if (typeof it === 'number' || typeof it === 'string') return String(it);
    var key = window.JY_FX_IDKEY === 'variant' ? (it.variantId || it.variant_id) : (it.product_id || it.productId);
    return String(key || it.variant_id || it.variantId || it.product_id || it.id || '');
  }
  function normalize(items) {
    return (items || [])
      .map(function (it) {
        return { id: idOf(it), quantity: (it && (it.quantity || it.qty)) || 1 };
      })
      .filter(function (c) {
        return c.id;
      });
  }
  function eid(tag) {
    /* stable-ish unique id without Date.now (kept CSP/replay-safe): tag + counter */
    eid._n = (eid._n || 0) + 1;
    return 'jy-' + (tag || 'e') + '-' + eid._n + '-' + (window.performance && performance.now ? Math.round(performance.now()) : eid._n);
  }


  /* in-app bridge: forward commerce events to the Flutter shell so it can log
     native app events. Carries BOTH the Facebook event name (`name`, e.g.
     AddToCart) and the AppsFlyer event name (`af`, e.g. af_add_to_cart) so the
     shell can fan out to Facebook App Events AND the AppsFlyer SDK from one call.
     No-op on the web — flutter_inappwebview only exists inside the app. */
  function appBridge(name, value, ids, afName) {
    try {
      // purchase is owned by the worker (S2S af_purchase) — never bridge it, per
      // the app contract, or in-app measurement would double-count
      if (afName === 'af_purchase') return;
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('jyEvent', {
          name: name,
          af: afName || '',
          value: typeof value === 'number' ? value : 0,
          currency: 'MAD',
          contentIds: ids || [],
        });
      }
    } catch (e) {}
  }

  function fire(names, data) {
    var contents = normalize(data.items);
    var ids = contents.map(function (c) {
      return c.id;
    });
    var value = typeof data.value === 'number' ? Math.round(data.value * 100) / 100 : undefined;
    var eventID = data.eventID || eid(names.fb);
    var plat = window.JY_IS_APP === true ? 'app' : 'web'; /* app vs web, on every channel */

    /* attach Advanced Matching (typed id, or logged-in customer) before the
       network events fire, so the Meta/TikTok browser events carry identity */
    applyMatch(data);

    try {
      if (window.fbq && names.fb) {
        fbq(
          'track',
          names.fb,
          {
            value: value,
            currency: CUR,
            content_type: 'product',
            content_ids: ids,
            contents: contents,
            num_items: data.num || contents.length || undefined,
            jy_platform: plat,
          },
          { eventID: eventID }
        );
      }
    } catch (e) {}

    try {
      var gaItems = contents.map(function (c) {
        return { item_id: c.id, quantity: c.quantity };
      });
      var payload = { value: value, currency: CUR, items: gaItems };
      if (data.id) payload.transaction_id = data.id;
      /* platform dimension: segment the GA4 funnel by app vs web (register
         jy_platform as an event-scoped custom dimension in GA4) */
      payload.jy_platform = plat;
      if (window.gtag && names.ga) gtag('event', names.ga, payload);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: names.ga }, payload));
    } catch (e) {}

    try {
      if (window.ttq && names.tt) {
        ttq.track(names.tt, {
          value: value,
          currency: CUR,
          content_type: 'product',
          content_id: ids[0],
          contents: contents,
          jy_platform: plat,
        });
      }
    } catch (e) {}

    /* Google Ads conversion action (COD orders skip Shopify checkout). Deduped
       by transaction_id (order id) inside Google Ads, so it's safe if it also
       fires elsewhere. Enhanced Conversions: pass plaintext identifiers — gtag
       hashes them when the account has Enhanced Conversions enabled. */
    try {
      if (window.gtag && names.gads && window.JY_GADS && window.JY_GADS.sendTo) {
        if (window.JY_GADS.enhanced) {
          var ud = userData(data);
          if (ud) gtag('set', 'user_data', ud);
        }
        gtag('event', 'conversion', {
          send_to: window.JY_GADS.sendTo,
          value: value,
          currency: CUR,
          transaction_id: data.id || undefined,
        });
      }
    } catch (e) {}

    appBridge(names.fb || names.ga, value, ids, names.af);

    return eventID;
  }

  function e164(phone) {
    var d = String(phone || '').replace(/[^\d]/g, '');
    if (!d) return '';
    if (d.indexOf('212') === 0) return '+' + d;
    if (d.charAt(0) === '0') return '+212' + d.slice(1);
    if (d.length === 9) return '+212' + d;
    return '+' + d;
  }
  function userData(data) {
    var ud = {};
    if (data.phone) ud.phone_number = e164(data.phone);
    if (data.email) ud.email = String(data.email).trim().toLowerCase();
    var addr = {};
    if (data.firstName) addr.first_name = data.firstName;
    if (data.lastName) addr.last_name = data.lastName;
    if (data.city) addr.city = data.city;
    if (data.street) addr.street = data.street;
    addr.country = 'MA';
    // only attach address when we have more than just the country
    var keys = 0;
    for (var k in addr) if (addr.hasOwnProperty(k)) keys++;
    if (keys > 1) ud.address = addr;
    return ud.phone_number || ud.email ? ud : null;
  }

  /* ---- Meta / TikTok Advanced Matching (browser) ------------------------
     Raises Event Match Quality by attaching the shopper's identifiers to
     browser events. Source: the id typed at COD checkout (passed in `data`),
     or window.JY_CUSTOMER for logged-in shoppers (injected in the layout) —
     so even ViewContent/AddToCart carry identity, not just Purchase. Meta
     hashes em/ph/fn/ln/ct in the browser before sending; nothing plaintext
     leaves the page. Fully guarded (can never break a track call) and mutates
     no DOM, so it respects the performance-team no-page-mutation rule. */
  function amDigits(p) {
    var d = String(p || '').replace(/[^\d]/g, '');
    if (!d) return '';
    if (d.charAt(0) === '0') return '212' + d.slice(1);
    if (d.length === 9) return '212' + d;
    return d;
  }
  function matchOf(data) {
    var s = data && (data.phone || data.email) ? data : window.JY_CUSTOMER || {};
    var am = {};
    var ph = amDigits(s.phone);
    if (ph) am.ph = ph;
    if (s.email) am.em = String(s.email).trim().toLowerCase();
    var fn = s.firstName || s.first_name;
    if (fn) am.fn = String(fn).trim().toLowerCase();
    var ln = s.lastName || s.last_name;
    if (ln) am.ln = String(ln).trim().toLowerCase();
    if (s.city) am.ct = String(s.city).trim().toLowerCase().replace(/\s+/g, '');
    if (!am.ph && !am.em) return null;
    am.country = 'ma';
    return am;
  }
  var _amSig = '';
  function applyMatch(data) {
    var am = matchOf(data);
    if (!am) return;
    var sig = JSON.stringify(am);
    if (sig === _amSig) return; /* only re-send when the identity actually changed */
    _amSig = sig;
    try {
      var pid = window.JY_META_PIXEL || '';
      if (window.fbq && pid) fbq('init', pid, am); /* updates Advanced Matching; emits no PageView */
    } catch (e) {}
    try {
      if (window.ttq && ttq.identify) {
        ttq.identify({ email: am.em || undefined, phone_number: am.ph ? '+' + am.ph : undefined });
      }
    } catch (e) {}
  }

  function cookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }

  /* Meta click-id resilience. Most Justyol traffic lands in the Meta in-app
     browser, which frequently drops the pixel-set _fbc/_fbp cookies between the
     landing page and the COD checkout — that's why the CAPI's fbc coverage sits
     ~14%. Fix: on first load persist whatever the pixel set, and if the click id
     is only in the URL (fbclid) synthesise the documented fb.1.<ts>.<fbclid>
     form. Later pages fall back to the persisted value, so our real-time server
     Purchase keeps the click attribution even after the cookie is gone. Read-only
     enhancement — it never overrides a live cookie the pixel still has. */
  function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { if (v) localStorage.setItem(k, v); } catch (e) {} }
  function resolveFbc() {
    var live = cookie('_fbc');
    if (live) { lsSet('jy_fbc', live); return live; }
    var m = location.search.match(/[?&]fbclid=([^&]+)/);
    if (m && m[1]) {
      var synth = 'fb.1.' + Date.now() + '.' + decodeURIComponent(m[1]);
      lsSet('jy_fbc', synth);
      return synth;
    }
    return lsGet('jy_fbc');
  }
  function resolveFbp() {
    var live = cookie('_fbp');
    if (live) { lsSet('jy_fbp', live); return live; }
    return lsGet('jy_fbp');
  }
  /* Google click id (gclid). gtag stores it in the _gcl_aw cookie as
     GCL.<ts>.<gclid>; persist it (and the raw ?gclid on landing) so the COD
     order can carry it → later Offline Conversion Import can upload the
     DELIVERED order to Google Ads (COD: many orders cancel, so uploading only
     delivered ones teaches the algo to find buyers, not cancellers). */
  function resolveGclid() {
    var live = cookie('_gcl_aw');
    if (live) {
      var m = live.match(/GCL\.\d+\.(.+)/);
      if (m && m[1]) { lsSet('jy_gclid', m[1]); return m[1]; }
    }
    var u = location.search.match(/[?&]gclid=([^&]+)/);
    if (u && u[1]) { var g = decodeURIComponent(u[1]); lsSet('jy_gclid', g); return g; }
    return lsGet('jy_gclid');
  }
  /* Session attribution (Task 5): COD orders are created via the Draft Order
     API, so Shopify's native customer-journey (landing page / referrer / source)
     comes back null. Capture first-touch landing + referrer + UTM per browsing
     session (sessionStorage) and forward them so the Worker stores them on the
     order for internal attribution. */
  function ssOnce(k, v) {
    try {
      if (v && !sessionStorage.getItem(k)) sessionStorage.setItem(k, v);
      return sessionStorage.getItem(k) || '';
    } catch (e) { return ''; }
  }
  function utmFirstTouch() {
    try {
      if (!sessionStorage.getItem('jy_utm')) {
        var parts = [];
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
          var m = location.search.match(new RegExp('[?&]' + k + '=([^&]+)'));
          if (m && m[1]) parts.push(k + '=' + decodeURIComponent(m[1]));
        });
        if (parts.length) sessionStorage.setItem('jy_utm', parts.join('&'));
      }
      return sessionStorage.getItem('jy_utm') || '';
    } catch (e) { return ''; }
  }
  /* Ad-visit attribution that survives the session (7 days). sessionStorage
     (above) was lost on a new tab, the Meta in-app browser handing off, or a
     return visit — the order then showed a later page and no ad. Remember the
     LAST ad/campaign visit in localStorage (a later visit with no ad params
     never erases it) and forward campaign / ad set / ad / click ids under the
     names Ads OS reads (campaign_id, adset_id, ad_id, click_id).
     Meta numeric UTMs map utm_campaign→campaign, utm_term→ad set,
     utm_content→ad; explicit campaign_id/adset_id/ad_id params win. */
  var ATTR_KEY = 'jy_attr';
  var ATTR_TTL = 7 * 24 * 3600 * 1000;
  function qp(k) {
    var m = location.search.match(new RegExp('[?&]' + k + '=([^&#]*)'));
    if (!m || !m[1]) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }
  function numId(v) { return /^\d{6,25}$/.test(v || '') ? v : ''; }
  function captureAdVisit() {
    var fbclid = qp('fbclid'), ttclid = qp('ttclid'), gclid = qp('gclid');
    var cmp = qp('utm_campaign'), term = qp('utm_term'), cnt = qp('utm_content');
    var cid = numId(qp('campaign_id')) || numId(cmp);
    var asid = numId(qp('adset_id')) || numId(term);
    var aid = numId(qp('ad_id')) || numId(cnt);
    if (!(fbclid || ttclid || gclid || qp('utm_source') || cid || aid)) return; // not an ad visit: keep the last one
    var utm = [];
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'].forEach(function (k) {
      var v = qp(k);
      if (v) utm.push(k + '=' + v);
    });
    try {
      localStorage.setItem(ATTR_KEY, JSON.stringify({
        ts: Date.now(),
        landing: (location.pathname + location.search).slice(0, 255),
        referrer: (document.referrer || '').slice(0, 255),
        utm: utm.join('&').slice(0, 255),
        campaign_id: cid,
        adset_id: asid,
        ad_id: aid,
        click_id: (fbclid || ttclid || gclid).slice(0, 255),
        click_src: fbclid ? 'fbclid' : ttclid ? 'ttclid' : gclid ? 'gclid' : '',
      }));
    } catch (e) {}
  }
  function adVisit() {
    try {
      var a = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null');
      if (a && a.ts && Date.now() - a.ts < ATTR_TTL) return a;
    } catch (e) {}
    return null;
  }
  try { captureAdVisit(); } catch (e) {}
  try { resolveFbc(); resolveFbp(); resolveGclid(); } catch (e) {} // capture click ids on landing
  try { ssOnce('jy_land', location.pathname + location.search); ssOnce('jy_ref', document.referrer); utmFirstTouch(); } catch (e) {}
  try { applyMatch({}); } catch (e) {} // seed Advanced Matching for logged-in shoppers

  window.JY_FX = {
    /* context forwarded to the backend so its server-side CAPI Purchase carries
       the same event_id (dedup) + fbp/fbc/ttp for match quality */
    pixelContext: function () {
      return {
        eventId: 'jy-p-' + Date.now() + '-' + Math.floor(Math.random() * 1e6),
        fbp: resolveFbp(),
        fbc: resolveFbc(),
        gclid: resolveGclid(),
        /* the remembered ad visit (≤7 days) wins over this session's first page,
           so an order placed in a new tab / later visit keeps its ad landing */
        landing: (adVisit() || {}).landing || ssOnce('jy_land'),
        referrer: (adVisit() || {}).referrer || ssOnce('jy_ref'),
        utm: (adVisit() || {}).utm || utmFirstTouch(),
        campaignId: (adVisit() || {}).campaign_id || '',
        adsetId: (adVisit() || {}).adset_id || '',
        adId: (adVisit() || {}).ad_id || '',
        clickId: (adVisit() || {}).click_id || '',
        clickSrc: (adVisit() || {}).click_src || '',
        attrTs: (adVisit() || {}).ts || 0,
        ttp: cookie('_ttp'),
        /* AppsFlyer device id + platform, injected by the app shell (window.
           JY_AF_ID / JY_AF_PLATFORM). Forwarded so the worker's server-side
           af_purchase (S2S) attributes the COD order to the right install. */
        afId: (window.JY_AF_ID || ''),
        afPlatform: (window.JY_AF_PLATFORM || ''),
        ua: navigator.userAgent,
        url: location.href,
      };
    },
    view: function (d) {
      return fire({ fb: 'ViewContent', ga: 'view_item', tt: 'ViewContent', af: 'af_content_view' }, d);
    },
    addToCart: function (d) {
      return fire({ fb: 'AddToCart', ga: 'add_to_cart', tt: 'AddToCart', af: 'af_add_to_cart' }, d);
    },
    /* cart-page view — GA4 only (Meta/TikTok have no standard cart-view event,
       and AddToCart already fires via the Web Pixel, so firing them here would
       double-count). Completes the funnel: view_cart -> begin_checkout -> purchase. */
    viewCart: function (d) {
      return fire({ fb: null, ga: 'view_cart', tt: null, af: 'af_list_view' }, d || {});
    },
    checkout: function (d) {
      return fire({ fb: 'InitiateCheckout', ga: 'begin_checkout', tt: 'InitiateCheckout', af: 'af_initiated_checkout' }, d);
    },
    purchase: function (d) {
      return fire({ fb: 'Purchase', ga: 'purchase', tt: 'CompletePayment', gads: true, af: 'af_purchase' }, d);
    },
  };
})();

/* ---- first-party funnel counters ------------------------------------------
   Shopify's sessions funnel went blind when orders moved to the COD backend
   (nothing reaches native checkout any more), Clarity samples a fraction, and
   pixels depend on ad-blockers/webviews. So each funnel step is counted once
   per session in OUR backend (worker /t -> KV):
     pdp_view -> atc -> checkout_open -> form_start
   ('purchase' is bumped server-side at order creation — authoritative, and
   the client cannot inject it). Pull the table with POST /funnel
   { key: SESSION_SECRET, days: 7 } on the same worker.
   Each step is also mirrored to Microsoft Clarity as a jy_* custom event so
   Clarity Funnels + recordings can be filtered per step. */
(function () {
  'use strict';
  var EP = 'https://justyol-cod.justyol.workers.dev';
  try {
    if (window.JY_COD_ENDPOINT) EP = new URL(window.JY_COD_ENDPOINT).origin;
  } catch (e) {
    /* keep default */
  }

  function mark(step) {
    var k = 'jyf_' + step;
    try {
      if (sessionStorage.getItem(k)) return;
      sessionStorage.setItem(k, '1');
    } catch (e) {
      /* private mode: count every hit rather than none */
    }
    /* Clarity mirror + session upgrade so funnel recordings win retention */
    try {
      if (window.clarity) {
        window.clarity('event', 'jy_' + step);
        if (step === 'checkout_open') window.clarity('upgrade', 'jy_checkout');
      }
    } catch (e) {}
    var body = JSON.stringify({
      e: step,
      p: window.JY_IS_APP === true ? 'app' : 'web',
      l: (document.documentElement.lang || 'fr').slice(0, 2),
    });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(EP + '/t', body)) return;
    } catch (e) {}
    try {
      fetch(EP + '/t', { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }

  /* AppsFlyer funnel → app bridge. Shopify's official Web Pixel fires
     ViewContent/AddToCart inside a sandbox that can't reach
     window.flutter_inappwebview, so the app never sees the funnel. Fire it here
     (main context, in-app only) so AppsFlyer gets it. Purchase stays server-side
     (worker S2S) — see docs/appsflyer-integration.md. */
  function afEvent(af, ids, value) {
    try {
      if (!window.flutter_inappwebview || !window.flutter_inappwebview.callHandler) return;
      window.flutter_inappwebview.callHandler('jyEvent', {
        af: af,
        name: '',
        value: typeof value === 'number' ? value : 0,
        currency: 'MAD',
        contentIds: ids || [],
      });
    } catch (e) {}
  }

  function boot() {
    var pdp = document.querySelector('[data-jy-pdp]');
    if (pdp) {
      mark('pdp_view');
      var pid = pdp.getAttribute('data-product-id');
      afEvent('af_content_view', pid ? [String(pid)] : []);
    }
    if (document.querySelector('[data-jy-codc]')) mark('checkout_open');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* successful add-to-cart (jy-pdp dispatches this after /cart/add succeeds) */
  document.addEventListener('product-ajax:added', function (e) {
    mark('atc');
    var p = e && e.detail && e.detail.product;
    var pid = p && (p.product_id || p.id);
    var val = p && typeof p.price === 'number' ? Math.round(p.price) / 100 : undefined;
    afEvent('af_add_to_cart', pid ? [String(pid)] : [], val);
  });
  /* COD express popup opened from the PDP */
  document.addEventListener('jy:cod:open', function () {
    mark('checkout_open');
    afEvent('af_initiated_checkout', []);
  });
  /* first interaction with a COD form (express popup or checkout page) */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.closest && t.matches && t.matches('input, select, textarea') && t.closest('[data-jy-codx], [data-jy-codc]')) {
      mark('form_start');
    }
  });
})();
